<div class="find-your-ideal text-left">
  <h2 class="mb-2">{{ 'FindYourIdealCar' | translate }}</h2>

  <form [formGroup]="searchForm" (ngSubmit)="onSubmit()">
  <!--Pickup-->
  <section class="pickup">
    <label>{{ 'Pickup' | translate }}</label>

    <div class="form-group">
      <div class="input-group">
          <span class="input-group-prepend">
              <span class="input-group-text disable-text">
                  <fa-icon [icon]="faMapMarkerAlt"></fa-icon>
              </span>
          </span>
         
          <input [value]="f.pickUpLocation.value | translate"   formControlName="pickUpLocation"
          class="form-control"
          [ngClass]="{ 'is-invalid': submitted && f.pickUpLocation.errors }" disabled />
      </div>
      <div *ngIf="submitted && f.pickUpLocation.errors" class="invalid-feedback">
          <div *ngIf="f.pickUpLocation.errors.required"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 pr-1">
        <div class="form-group">
          <div class="pick-up-date">
              <mat-form-field class="form-control" appearance="none">
                  <mat-datepicker-toggle matPrefix [for]="PickUpDate"></mat-datepicker-toggle>
                  <mat-datepicker #PickUpDate></mat-datepicker>
                  <input  readonly [placeholder]="minPickUpDate" formControlName="PickUpDate" matInput [min]="minPickUpDate" [matDatepicker]="PickUpDate" (click)="PickUpDate.open()"
                  (dateInput)="addEvent(1,'input', $event)" (dateChange)="addEvent(1,'change', $event)"
                  [attr.disabled]="disableSearch ? '' : null"
                  >
              </mat-form-field>
          </div>
        </div>
      </div>
      <div class="col-md-6 pl-2">
        <div class="form-group">
          <div class="pick-up-time">
              <fa-icon class="time-icon" [icon]="faClock"></fa-icon>
              <input [placeholder]="minTime" formControlName="PickUpTime" id="pickUpTime"  [attr.disabled]="disableSearch ? '' : null" />
          </div>
        </div>
      </div>
    </div>
  </section>

  <!--Drop-off-->
  <section class="drop-off">
    <label>{{ 'Return' | translate }}</label>
    <div class="form-group">
      <div class="input-group">
          <span class="input-group-prepend">
              <span [ngClass]="disableSearch ?'disable-text':'available-text'"  class="input-group-text">
                  <fa-icon [icon]="faMapMarkerAlt"></fa-icon>
              </span>
          </span>

            <mat-select panelClass="find-ideal-car-select" formControlName="dropOffLocation" [(value)]="selectedLocation" class="form-control select-control "
            disableOptionCentering  [disabled]="disableSearch" [attr.disabled]="disableSearch ? '' : null">
              <mat-option   *ngFor="let dropUpLocation of returnLocations"  [selected]="dropUpLocation.returnAgencyID === selectedLocation" [value]="dropUpLocation.returnAgencyID">
                {{dropUpLocation.agencyReturnLocationName | translate}}
              </mat-option>
            </mat-select>


      </div>
      <div *ngIf="submitted && f.location.errors" class="invalid-feedback">
          <div *ngIf="f.location.errors.required"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 pr-1">
        <div class="form-group">
          <div class="drop-off-date">
            <mat-form-field appearance="none">
                <mat-datepicker-toggle matPrefix [for]="dropUpDate"></mat-datepicker-toggle>
                <mat-datepicker #dropUpDate></mat-datepicker>
                <input readonly [placeholder]="minDropOffDate"  formControlName="dropUpDate" matInput
                [min]="minDropOffDate"  [matDatepicker]="dropUpDate" (click)="dropUpDate.open()"
                (dateInput)="addEvent(2,'input', $event)" (dateChange)="addEvent(2,'change', $event);dropUpDate.open()"
                [attr.disabled]="disableSearch ? '' : null"
                >
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="col-md-6 pl-2">
        <div class="form-group">
          <div class="drop-off-time">
            <fa-icon class="time-icon" [icon]="faClock"></fa-icon>
            <input [placeholder]="minTime" formControlName="dropUpTime" id="dropUpTime"  [attr.disabled]="disableSearch ? '' : null"/>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="text-center">
    <button class="btn search-btn"

     *ngIf="!disableSearch"
     >{{ 'FindBtn' | translate }}</button>
  </div>


  <!--Pickup-->
  </form>

</div>
<simple-notifications></simple-notifications>





